// src/Cache.js
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

// 1) Context + Provider
const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState({
    matches: [],
    lastFiveMatches: [],
    players: [],
    teams: [],
    playerStatistics1: [],
    leagues: [],
    seasons: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [
        matchesRes,
        lastFiveMatchesRes,
        playersRes,
        teamsRes,
        playerStatisticsRes,
        leaguesRes,
        seasonsRes,
      ] = await Promise.all([
        axios.get("https://elit-lig-back-end-bc5730e96b98.herokuapp.com/maclar"),
        axios.get("https://elit-lig-back-end-bc5730e96b98.herokuapp.com/maclar/last-five"),
        axios.get("https://elit-lig-back-end-bc5730e96b98.herokuapp.com/oyuncular/"),
        axios.get("https://elit-lig-back-end-bc5730e96b98.herokuapp.com/takimlar/"),
        axios.get("https://elit-lig-back-end-bc5730e96b98.herokuapp.com/oyuncu-istatistikleri/"),
        axios.get("https://elit-lig-back-end-bc5730e96b98.herokuapp.com/ligler"),
        axios.get("https://elit-lig-back-end-bc5730e96b98.herokuapp.com/sezonlar"),
      ]);

      setData({
        matches: matchesRes.data,
        lastFiveMatches: lastFiveMatchesRes.data,
        players: playersRes.data,
        teams: teamsRes.data,
        playerStatistics1: playerStatisticsRes.data,
        leagues: leaguesRes.data,
        seasons: seasonsRes.data,
      });
    } catch (err) {
      console.error("Veri çekme hatası:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ ...data, loading, error }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);

// ─────────────────────────────────────────────────────────────
// 2) normalize yardımcı fonksiyonu (Home.js ile çakışmasın diye tekrar koyuyoruz)
function normalize(str = "") {
  return str
    .toLowerCase()
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/ö/g, "o")
    .replace(/ş/g, "s")
    .replace(/ü/g, "u")
    .replace(/[^a-z0-9 ]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

// 3) getPlayerStatsByLeague: sadece seçili şehrin, ligin ve sezonun maçlarındaki oyuncu istatistiklerini döner
export function getPlayerStatsByLeague(
  matches,
  players,
  playerStatistics,
  cityName,
  leagueName,
  seasonName,
  sortBy = "goals" // "goals" veya "value"
) {
  // 3.1) Önce o sezonun maçlarını filtrele
  const matchIdsInSeason = new Set(
    matches
      .filter(
        (m) =>
          normalize(m.city) === cityName &&
          normalize(m.league_name) === leagueName &&
          m.match_season === seasonName
      )
      .map((m) => m.id)
  );

  // 3.2) İstatistikleri bu maçlara göre daralt
  const statsByPlayer = {};

  playerStatistics
    .filter((stat) => matchIdsInSeason.has(stat.match_id))
    .forEach((stat) => {
      const p = players.find((p) => p.id === stat.player_id);
      if (!p) return;

      if (!statsByPlayer[p.id]) {
        statsByPlayer[p.id] = {
          id: p.id,
          player_name: p.player_name,
          team_name: p.team_name,
          player_img: p.player_img,
          total_goals: 0,
          total_matches: 0,
          total_points: 0,
          value: 0,
        };
      }
      statsByPlayer[p.id].total_goals += stat.number_of_goals || 0;
      statsByPlayer[p.id].total_matches += 1;
      statsByPlayer[p.id].total_points += stat.points || 0;
    });

  // 3.3) 'value' metriğini hesapla
  Object.values(statsByPlayer).forEach((p) => {
    const m = p.total_matches || 1;
    p.value = (
      (p.total_points / m) * 100 + // maç başı puan
      m * 20                         // maç sayısı ağırlığı
    ).toFixed(2);
  });

  // 3.4) Sırala ve return et
  return Object.values(statsByPlayer).sort((a, b) => {
    if (sortBy === "goals") {
      return b.total_goals - a.total_goals;
    }
    return b.value - a.value;
  });
}
